import { select, Store } from '@ngrx/store';
import { State } from '@app/store/state/state';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import * as actions from '@recent-searches/store/actions/recent-searches.actions';
import { RecentSearchModel } from '@recent-searches/entities/recent-search';
import { recentSearchesRootSelector } from '@recent-searches/store/selectors/recent-searches-root.selector';

@Injectable()
export class RecentSearchesFacade {
  constructor(
    private readonly store: Store<State>
  ) { }

  public recentSearches$: Observable<RecentSearchModel[]> = this.store.pipe(
    select(recentSearchesRootSelector),
    map(state => state.recentSearches)
  );

  public fetchRecentSearches(): void {
    this.store.dispatch(actions.fetchRecentSearchesAction());
  }
  
  public deleteRecentSearches(): void {
    this.store.dispatch(actions.deleteRecentSearchesAction());
  }
}
